import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import "bootstrap/dist/css/bootstrap.min.css"
import "./App.css"
import LoginPage from "./pages/LoginPage"
import RegisterPage from "./pages/RegisterPage"
import DashboardPage from "./pages/DashboardPage"
import ProfilePage from "./pages/ProfilePage"
import CoursesPage from "./pages/CoursesPage"
import EnrolledCoursesPage from "./pages/EnrolledCoursesPage"
import CourseDetailPage from "./pages/CourseDetailPage"
import WishlistPage from "./pages/WishlistPage"
import SettingsPage from "./pages/SettingsPage"
import CoursePlayerPage from "./pages/CoursePlayerPage"
import QuizAttemptsPage from "./pages/QuizAttemptsPage"
import QuizDetailPage from "./pages/QuizDetailPage"
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

import UserQuestionsPage from "./pages/UserQuestionsPage"
import QuestionDetail from "./pages/QuestionDetailPage"
import PrivateRoute from "./components/PrivateRoute"

import Watermark from "./components/Watermark";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
    <Router>
      <div className="App">
      <Watermark brand="Nurse Assist International" />
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:uidb64/:token" element={<ResetPasswordPage />} />
          
          <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
          <Route path="/courses" element={<PrivateRoute><CoursesPage /></PrivateRoute>} />
          <Route path="/enrolled-courses" element={<PrivateRoute><EnrolledCoursesPage /></PrivateRoute>} />
          <Route path="/course/:id" element={<PrivateRoute><CourseDetailPage /></PrivateRoute>} />
          <Route path="/course/:id/learn" element={<PrivateRoute><CoursePlayerPage /></PrivateRoute>} />
          <Route path="/course/:id/learn/:lessonId" element={<PrivateRoute><CoursePlayerPage /></PrivateRoute>} />
          <Route path="/wishlist" element={<PrivateRoute><WishlistPage /></PrivateRoute>} />
          <Route path="/questions" element={<PrivateRoute><UserQuestionsPage /></PrivateRoute>} />
          <Route path="/questions/:id" element={<PrivateRoute><QuestionDetail /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
          <Route path="/settings/:tab" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
          <Route path="/quiz-attempts" element={<PrivateRoute><QuizAttemptsPage /></PrivateRoute>} />
          <Route path="/quiz-detail/:id" element={<PrivateRoute><QuizDetailPage /></PrivateRoute>} />
        </Routes>
      </div>
    </Router>
    <ToastContainer position="top-right" autoClose={3000} />
    </>
  )
}

export default App
